/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Trend_1y1Inputs */

const en_coinvestments_report_trend_1y1 = /** @type {(inputs: Coinvestments_Report_Trend_1y1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1Y`)
};

/**
* | output |
* | --- |
* | "1Y" |
*
* @param {Coinvestments_Report_Trend_1y1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_trend_1y1 = /** @type {((inputs?: Coinvestments_Report_Trend_1y1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Trend_1y1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_trend_1y1(inputs)
});
export { coinvestments_report_trend_1y1 as "coInvestments_report_trend_1y" }